import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwalService {

  constructor(private translate: TranslateService) { }

  public swalConfirmation(confirmButtonText: string, title = '', text = '') {
    return Swal.fire({
      title: title ? title : this.translate.instant('swalMsg.Areyousure'),
      text,
      // icon: 'warning',
      imageUrl: './assets/images/icons/warning-ic.svg',
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText: this.translate.instant('swalMsg.cancel')
    });
  }

  public swalFailed(text: string) {
    return Swal.fire({
      title: this.translate.instant('swalMsg.Failed'),
      text,
      icon: 'error',
      confirmButtonText: this.translate.instant('swalMsg.Ok'),
    });
  }

  public swalSuccess(text: string = '', confirmButtonText = this.translate.instant('swalMsg.Ok'), titleText: string = '') {
    return Swal.fire({
      title: this.translate.instant('swalMsg.Success'),
      text,
      titleText,
      icon: 'success',
      confirmButtonText
    });
  }

  public swalWarning(text: string = '', title: string = '') {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      confirmButtonText: this.translate.instant('swalMsg.Ok')
    });
  }

}
